import axios from '../axios-data'
import * as jsonHeaders from './serviceHeaders'

export const branchRequest = async (app, branchId, token) => {
  try {
    let url = `/branch/${app.state.branchId}`
    const headers = jsonHeaders.getTokenizedHeaders(token)
    return await axios
      .get(url, {
        headers: headers,
      })
      .then(resp => {
        return resp.data
      })
  } catch (ex) {
    console.log(ex)
  }
}
